<template>
<v-container fluid class="fill-height">
    <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4 lg3>
            <ValidationObserver ref="obs" v-slot="{ invalid, validated, passes, validate }">
                <material-card class="text-center title font-weight-bold" color="cardheader" title="Вхiд">
                    <v-card-text>
                        <v-alert type="error" v-if="errorMessage" outlined>
                            {{errorMessage}}
                        </v-alert>
                        <validation-provider v-slot="{ errors, valid }" rules="required|tel">
                            <v-text-field v-show="!codeCheck" :success="valid" persistent-hint hint="Введiть телeфон користувача" prepend-icon="mdi-phone" name="phone" label="Телефон" placeholder="+38(000) 000 - 0000" v-mask="maskTel" v-model="f.phone"></v-text-field>
                        </validation-provider>
                        <validation-provider v-if="codeCheck" v-slot="{ errors, valid }" rules="required|length:5">
                            <v-text-field v-show="codeCheck" :success="valid" persistent-hint hint="Введiть SMS-код підтвердження" prepend-icon="mdi-cellphone-text" name="code" label="Код з SMS" placeholder="00000" v-mask="maskCode" v-model="f.code"></v-text-field>
                        </validation-provider>
                    </v-card-text>
                    <!-- <v-card-actions>
                                <v-spacer></v-spacer>
                                <router-link to="/registration"><span class="red--text">Реестрацiя нового користувача</span></router-link>
                                <v-spacer></v-spacer>
                            </v-card-actions> -->
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="cardheader" :loading="loading" text @click="passes(submitForm)" :disabled="invalid || !validated">Надiслати</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </material-card>
            </ValidationObserver>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
import {
    mask
} from 'vue-the-mask'

import {
    ValidationObserver,
    ValidationProvider
} from "vee-validate"

import {
    mapActions
} from 'vuex'

export default {
    components: {
        ValidationProvider,
        ValidationObserver
    },
    directives: {
        mask
    },
    data() {
        return {
            loading: false,
            maskTel: '+38(###) ###-####',
            maskCode: '#####',
            codeCheck: false,
            errorMessage: '',
            f: {}
        }
    },
    methods: {
        ...mapActions(['login', 'verify', 'setSnackbar']),
        getLocalStorage(f) {
            return JSON.parse(localStorage[f])
        },
        setLocalStorage(f, v) {
            localStorage[f] = JSON.stringify(v)
        },
        async submitForm() {
            this.errorMessage = ''
            this.loading = true
            // Execute reCAPTCHA with action "login".
            await this.$recaptchaLoaded()
            this.f.reCAPTCHA = await this.$recaptcha('login')

            if (this.f.code) {
                this.verify(this.f)
                    .then(d => {
                        this.loading = false
                        if (d.token && d.refreshToken) {
                            this.setLocalStorage('authToken', d.token)
                            this.setLocalStorage('refreshToken', d.refreshToken)
                        }
                        this.$router.push('/')
                    })
                    .catch(
                        (error) => {
                            this.loading = false
                            if (error.response && error.response.status == 403) {
                                this.errorMessage = 'Код не вiрний, або термiн коду збiг!'
                            }
                        }
                    )
            } else {
                this.login(this.f)
                    .then(
                        (d) => {
                            this.loading = false
                            this.codeCheck = true
                            this.f.token = d.token
                        }
                    )
                    .catch(
                        (error) => {
                            this.loading = false
                            if (error.response && error.response.status == 403) {
                                this.errorMessage = 'Такого користувача не існує!'
                            } else if (error.response && error.response.status == 401) {
                                this.errorMessage = 'Помилка! Спробуйте ще раз!'
                            } else {
                                this.setSnackbar(['error', error.response.status + ' ' + error.response.statusText])
                            }
                        }
                    )
            }
        },
    },
}
</script>

<style>
</style>
